import React from 'react';
import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link, useHistory } from 'react-router-dom';
import { PageTitle } from '@cordata/buffet';

import { UncontrolledTable } from '~/components/common';

import { useAdmin } from '~/utils/admin';

const defaultSorted = [{
  id: 'facility-name',
}];

const columns = [{
  id: 'facilityName',
  Header: 'Name',
  accessor: 'attributes.facilityName',
}, {
  id: 'isInSelections',
  Header: 'Is In Selections',
  accessor: 'attributes.isInSelections',
  Cell: c => (c && c.value ? <div className="text-success text-center"><FontAwesomeIcon icon="check" /></div> : null),
  minWidth: 25,
  filterable: false,
}];

const Facilities = () => {
  const history = useHistory();
  const { org } = useAdmin();

  return (
    <>
      <PageTitle
        action={
          <Button
            outline
            tag={Link}
            to="/admin/facilities/add"
          >
            <FontAwesomeIcon icon="plus" />
            <span className="d-none d-md-inline ml-2">Add Facility</span>
          </Button>
        }
      >
        Facilities
      </PageTitle>

      {org &&
        <UncontrolledTable
          name="facilities"
          defaultSorted={defaultSorted}
          endpoint={{
            url: 'admin/facility',
            params: {
              'org-uid': org.id,
            },
          }}
          columns={columns}
          getTrProps={(state, rowInfo) => ({
            style: {
              cursor: 'pointer',
            },
            onClick: (e, handleOriginal) => (handleOriginal ? handleOriginal() : history.push(`/admin/facilities/${rowInfo.original.id}`)),
          })}
        />
      }
    </>
  );
};

export default Facilities;
